export const styles = {
    shareBtn: (bg_color) => {
        return {
            backgroundColor: bg_color,
            borderColor: bg_color,
            color: "white"
        }
    }
}